import { TFunction } from 'i18next';

import {
  ExternalSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';

class Comparison extends ExternalSeriesGenerator {
  isSeparateFromPriceChart = false;
  shareYAxisWithPriceChart = false;
  height = -1;
  name: string;
  data: (string | number)[][];
  colorStyle: string;

  constructor(
    name: string,
    t: TFunction,
    data: (string | number)[][],
    colorStyle: string
  ) {
    super(t);
    this.name = name;
    this.data = data;
    this.colorStyle = colorStyle;
  }

  getChartName(): string {
    return this.name;
  }

  getSeries(): PriceViewerSeries {
    return {
      name: this.getChartName(),
      echartSeries: {
        type: 'line',
        data: this.data,
        symbol: 'none',
        lineStyle: {
          opacity: 0.5,
          color: this.colorStyle,
        },
      },
      tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
        keyColor: this.colorStyle,
      }),
    };
  }
}

export default Comparison;
